export default "__VITE_ASSET__BIZ5rQO$__"